/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormShareBase,
    FormShareBaseFromJSON,
    FormShareBaseFromJSONTyped,
    FormShareBaseToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormShareBasesListResponse
 */
export interface FormShareBasesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormShareBasesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<FormShareBase>}
     * @memberof FormShareBasesListResponse
     */
    entries: Array<FormShareBase>;
}

export function FormShareBasesListResponseFromJSON(json: any): FormShareBasesListResponse {
    return FormShareBasesListResponseFromJSONTyped(json, false);
}

export function FormShareBasesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormShareBasesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(FormShareBaseFromJSON)),
    };
}

export function FormShareBasesListResponseToJSON(value?: FormShareBasesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(FormShareBaseToJSON)),
    };
}


